<template src="./login.html"></template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useToast } from "@/composables/UseToast";
import { richiedi_reset_password } from "@/api/api.amministrazione";

export default {
  name: "LoginForm",

  setup() {
    const toast = useToast();
    const store = useStore();
    const router = useRouter();

    // ── Login ────────────────────────────────────────────────────────────

    const e1 = ref(true);
    const attesa = ref(false);
    const formLogin = ref(null);
    const cred = ref({ username: "", password: "" });

    const submit = async () => {
      window.scrollTo(0, 0);
      if (!formLogin.value.validate()) return;

      attesa.value = true;
      try {
        await store.dispatch("auth/login", cred.value);
        router.push({ path: "/" });
      } catch {
        toast.error("Username o password errati");
      } finally {
        attesa.value = false;
      }
    };

    // ── Reset password ───────────────────────────────────────────────────

    const dialogReset = ref(false);
    const resetStep = ref(1);       // 1 = form email, 2 = conferma
    const resetEmail = ref("");
    const attesaReset = ref(false);
    const formReset = ref(null);

    const apriResetPassword = () => {
      resetEmail.value = "";
      resetStep.value = 1;
      dialogReset.value = true;
    };

    const chiudiReset = () => {
      dialogReset.value = false;
    };

    const inviaReset = async () => {
      const { valid } = await formReset.value.validate();
      if (!valid) return;

      attesaReset.value = true;
      try {
        await richiedi_reset_password(resetEmail.value);
        // Passa sempre allo step 2 indipendentemente dall'esito:
        // non rivelare se l'email esiste o meno nel sistema
        resetStep.value = 2;
      } catch {
        // In caso di errore di rete mostriamo comunque lo step 2
        // per non esporre informazioni sull'esistenza dell'account
        resetStep.value = 2;
      } finally {
        attesaReset.value = false;
      }
    };

    return {
      // login
      e1, cred, attesa, formLogin, submit,
      // reset
      dialogReset, resetStep, resetEmail, attesaReset, formReset,
      apriResetPassword, chiudiReset, inviaReset,
    };
  },
};
</script>

<style scoped>
.login-container {
  background: linear-gradient(135deg, #1E3A5F 0%, #14273F 100%);
}

.login-card {
  border-radius: 12px;
}

@media (max-width: 600px) {
  .login-card {
    border-radius: 0;
    min-height: 100vh;
  }
}
</style>